export default __webpack_public_path__ + "static/media/Camion5.f6db7b98.png";